import React, { Fragment, useState } from 'react';
import { Col, Container, Row, Card, CardBody, Progress } from 'reactstrap';


const DoctorProfile = () => {
    const [totalPatientAttended, setTotalPatientAttended] = useState(0);
    return (
        <Fragment>
            <Col md={5} lg={5} xl={3} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                    <div className='dashboard__visitors-technologist'>
                            <div className='title'><h5><b>Pacientes Atendidos</b></h5></div>
                            <div className="mobile-app-widget">
                                <div className="mobile-app-widget__top-line mobile-app-widget__top-line--blue">
                                    <p className="mobile-app-widget__total-stat">{totalPatientAttended} </p> 
                                </div>
                                <div className="progress-wrap progress-wrap--small progress-wrap--blue-gradient progress-wrap--label-top">
                                    <Progress value={totalPatientAttended}><p className="progress__label"></p></Progress>
                                </div>
                                <hr />
                            </div>

                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}

export default DoctorProfile